import React, {forwardRef} from 'react';
import BaseSimpleItemBrowser from "../BaseSimplePage/BaseSimpleItemBrowser";

const LocationsItemBrowser = forwardRef(({
                                               ...restProps
                                           }, ref) => {

    function getItemSubtitle(item) {
        return `${item.short_name}`;
    }

    return (
        <BaseSimpleItemBrowser
            {...restProps}
            ref={ref}
            getItemSubtitleFunc={getItemSubtitle}
            searchPlaceholder={"в названиях, в адресах сайтов"}
        />
    );
});

export default LocationsItemBrowser;